import { useEffect, useRef, useCallback } from 'react';
import { api } from '@/lib/api';

const GPS_INTERVAL_MS = 15000; // Report every 15 seconds

export function useDriverGPS(token, user, activeLoadId) {
  const intervalRef = useRef(null);
  const lastReportRef = useRef(null);

  const reportLocation = useCallback(async () => {
    // Always track if user is a driver, regardless of active load
    if (!token || !user || user.role !== 'driver') return;
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        if (lastReportRef.current) {
          const dLat = Math.abs(latitude - lastReportRef.current.lat);
          const dLng = Math.abs(longitude - lastReportRef.current.lng);
          if (dLat < 0.0001 && dLng < 0.0001) return;
        }
        lastReportRef.current = { lat: latitude, lng: longitude };
        try {
          await api.post('/tracking/location', {
            driver_id: user.user_id,
            load_id: activeLoadId || undefined,
            lat: latitude,
            lng: longitude,
          });
        } catch { /* silently fail */ }
      },
      () => { /* geolocation error */ },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 5000 }
    );
  }, [token, user, activeLoadId]);

  useEffect(() => {
    // Always start tracking for drivers
    if (!token || !user || user.role !== 'driver') {
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }
    reportLocation();
    intervalRef.current = setInterval(reportLocation, GPS_INTERVAL_MS);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [token, user, reportLocation]);
}
